import {Navigate, useLocation} from "react-router-dom";
import React from "react";

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({children}: RequireAuthProps) {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" state={{from: location}} replace />;
  }

  return <>{children}</>;
}

export default RequireAuth;